module.exports = __webpack_public_path__ + "img/askia.66e2f6c1.png";